import React, { useState } from 'react'
import cx from 'classnames'
import $t from '../../../i18n'

import './DismissibleSiteBanner.css'

export const SITE_BANNER_DISMISSED_STORAGE_KEY = 'patient_site_banner_dismissed'

const isBannerDismissed = storageKey =>
  localStorage.getItem(storageKey) === 'true'

const DismissibleSiteBanner = ({
  message = null,
  storageKey = SITE_BANNER_DISMISSED_STORAGE_KEY
}) => {
  const bannerMessage = message ?? $t('header.dismissableSiteBanner')
  const [isVisible, setIsVisible] = useState(
    () => !isBannerDismissed(storageKey)
  )

  const dismiss = () => {
    try {
      localStorage.setItem(storageKey, 'true')
    } catch {
      // Safari private mode / blocked storage — still hide for this session
    }
    setIsVisible(false)
  }

  return (
    <div className="site-banner-shell">
      <div
        className={cx('dismissible-site-banner', {
          'dismissible-site-banner--hidden': !isVisible
        })}
        role='region'
        aria-label='Announcement'
      >
        <div className='dismissible-site-banner__message'>{bannerMessage}</div>
        <button
          type='button'
          className='dismissible-site-banner__close'
          aria-label='Dismiss announcement'
          onClick={dismiss}
        >
          <i className='icon icon-close' aria-hidden='true' />
        </button>
      </div>
    </div>
  )
}

export default DismissibleSiteBanner
